<template>
  <div>
    <nav-bar-top icons-are-hidden is-primary />
    <div class="container has-nav-top-margin">
      <section class="section log-in-form-container">
        <log-in-form
          v-if="!isForgotPasswordFormVisible"
          @togglePasswordResetForm="handleTogglePasswordResetForm"
        />
        <reset-password-form v-else @toggleLoginForm="toggleLoginForm($event)" />
      </section>
    </div>
  </div>
</template>

<script>
import NavBarTop from '@/components/Navigation/NavBarTop';
import LogInForm from '@/components/Login/LogInForm';
import ResetPasswordForm from '@/components/Login/ResetPasswordForm';

export default {
  name: 'LogInView',
  components: {
    LogInForm,
    NavBarTop,
    ResetPasswordForm
  },
  data () {
    return {
      isForgotPasswordFormVisible: false
    };
  },
  methods: {
    handleTogglePasswordResetForm () {
      this.isForgotPasswordFormVisible = true;
    },
    toggleLoginForm ($event) {
      this.isForgotPasswordFormVisible = !$event;
    }
  }
};
</script>

<style lang="scss" scoped>
.log-in-form-container {
  max-width: 400px;
  margin: 0 auto;
}
</style>
